import { render, staticRenderFns } from "./BuildingItem.vue?vue&type=template&id=4c82a87a"
import script from "./BuildingItem.vue?vue&type=script&lang=js"
export * from "./BuildingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports